// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5d43d0b0","232":"9bfec64f","409":"81a5a148","453":"75558930"}[chunkId] + ".chunk.js";
};